/// <reference path="../../services/context-menu.service.js" />
const mod = require('../../bahabot.module.js')


/**
 * @param {ContextMenuService} ContextMenuService
 * @param $document angular.IDocument
 */
function bbContextMenu(ContextMenuService, $element, $scope, $document, $timeout) {
    this.svc = ContextMenuService;
    this.readyToShow = false;
    this.position = { top: 0, left: 0 };

    $scope.$watch(() => this.svc.renderKey, (key) => {
        if (this.svc.visible) {
            $timeout(() => {
                /**
                 * @type {angular.IAugmentedJQuery}
                 */
                const menuEl = $element;
                if (!menuEl.length) return;

                const menuRect = menuEl.children()[0].getBoundingClientRect();
                const menuWidth = menuRect.width;
                const menuHeight = menuRect.height;

                const { innerWidth, innerHeight, scrollX, scrollY } = window;

                let top = this.svc.position.top;
                let left = this.svc.position.left;

                if (left + menuWidth - scrollX > innerWidth) {
                    left = scrollX + innerWidth - menuWidth - 30;
                }

                if (top + menuHeight - scrollY > innerHeight) {
                    top = scrollY + innerHeight - menuHeight - 30;
                }

                this.position = { top, left };
                this.readyToShow = true;

                $scope.$applyAsync(); // just in case
            });
        } else {
            this.readyToShow = false;
        }
    });

    let onMouseDown = (e) => {
        const menuEl = $element[0].querySelector('[ng-show]');
        if (menuEl && !menuEl.contains(e.target)) {
            this.svc.close();
            $scope.$applyAsync(); // document is outside digest loop
        }
    };

    $scope.$watch(() => this.svc.visible, (visible) => {
        if (visible) {
            $document.on('mousedown', onMouseDown);
        } else {
            $document.off('mousedown', onMouseDown);
        }
    });
}

mod.component('bbContextMenu', {
    templateUrl: 'tpl/context-menus/generic.cm.html',
    bindings: {},
    controller: ["ContextMenuService", "$element", "$scope", "$document", "$timeout", bbContextMenu]
});